import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import { ChevronLeft16Regular, ChevronRight16Regular } from '@fluentui/react-icons';
import { cn } from '../../utils/cn';

type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        months: 'flex flex-col sm:flex-row gap-2',
        month: 'flex flex-col gap-4',
        month_caption: 'flex justify-center pt-1 relative items-center text-sm font-medium',
        nav: 'flex items-center gap-1',
        button_previous:
          'absolute left-1 top-0 inline-flex items-center justify-center size-7 bg-transparent p-0 opacity-50 hover:opacity-100 transition-opacity',
        button_next:
          'absolute right-1 top-0 inline-flex items-center justify-center size-7 bg-transparent p-0 opacity-50 hover:opacity-100 transition-opacity',
        month_grid: 'w-full border-collapse',
        weekdays: 'flex',
        weekday: 'text-neutral-500 w-8 font-normal text-[0.8rem]',
        week: 'flex w-full mt-2',
        day: 'relative p-0 text-center text-sm focus-within:relative focus-within:z-20',
        day_button: cn(
          'inline-flex items-center justify-center size-8 p-0 font-normal transition-colors',
          'hover:bg-blue-50 hover:text-blue-900',
          'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500/20'
        ),
        selected:
          'bg-blue-600 text-white hover:bg-blue-600 hover:text-white focus:bg-blue-600 focus:text-white [&>button]:bg-blue-600 [&>button]:text-white hover:[&>button]:bg-blue-700',
        today: '[&>button]:bg-neutral-100 [&>button]:text-neutral-900',
        outside: '[&>button]:text-neutral-400 [&>button]:opacity-50',
        disabled: '[&>button]:text-neutral-400 [&>button]:opacity-50 [&>button]:cursor-not-allowed',
        hidden: 'invisible',
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation }) => {
          const Icon = orientation === 'left' ? ChevronLeft16Regular : ChevronRight16Regular;
          return <Icon className="size-4" />;
        },
      }}
      {...props}
    />
  );
}

export { Calendar };
export type { CalendarProps };
